import { render, staticRenderFns } from "./PackageModal.vue?vue&type=template&id=711b1a58&"
import script from "./PackageModal.vue?vue&type=script&lang=js&"
export * from "./PackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports